import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
function parsedHasExpectedKey(key, parsed) {
  if (_typeof(parsed) !== 'object' || parsed === null || !(key in parsed)) {
    return false;
  }
  return true;
}

/**
 * This processes information from startStreamingResponse() and yields events
 * over to streamingService().
 */
export function streamResponseParser(_x) {
  return _streamResponseParser.apply(this, arguments);
}
function _streamResponseParser() {
  _streamResponseParser = _wrapAsyncGenerator(function (_ref) {
    var streamingResponseGenerator = _ref.streamingResponseGenerator,
      isConvoAI = _ref.isConvoAI,
      streamingListener = _ref.streamingListener;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var partialMeta, partial, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, yieldedResponse, loadingStatus, _message$message2, _ref2, message, _message$message, rovoActions, statusCode, guard, error, retryAfter, responseTooSimilarData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            partialMeta = {
              inputOutputDiffRatio: ''
            };
            partial = {
              type: 'markdown',
              content: '',
              meta: partialMeta,
              rovoActions: []
            };
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(streamingResponseGenerator);
          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());
          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 77;
              break;
            }
            yieldedResponse = _step.value;
            if (!(yieldedResponse.state === 'loaded-stream')) {
              _context.next = 14;
              break;
            }
            _context.next = 13;
            return {
              state: 'loaded',
              data: partial
            };
          case 13:
            return _context.abrupt("return", _context.sent);
          case 14:
            if (!(yieldedResponse.state === 'loading' || yieldedResponse.state === 'loaded')) {
              _context.next = 64;
              break;
            }
            if (!parsedHasExpectedKey('generatedContent', yieldedResponse.data)) {
              _context.next = 22;
              break;
            }
            partial = {
              type: 'markdown',
              content: partial.content + yieldedResponse.data['generatedContent'],
              rovoActions: partial.rovoActions,
              meta: parsedHasExpectedKey('meta', yieldedResponse.data) && parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio'],
                loadingStatus: ''
              } : partial.meta
            };
            if (streamingListener) {
              streamingListener(partial.content, yieldedResponse.state);
            }
            _context.next = 20;
            return {
              state: yieldedResponse.state,
              data: partial
            };
          case 20:
            _context.next = 62;
            break;
          case 22:
            if (!isConvoAI) {
              _context.next = 59;
              break;
            }
            if (!parsedHasExpectedKey('type', yieldedResponse.data)) {
              _context.next = 55;
              break;
            }
            if (yieldedResponse.data.type === 'TRACE') {
              loadingStatus = parsedHasExpectedKey('message', yieldedResponse.data) && parsedHasExpectedKey('message_template', yieldedResponse.data.message) ? yieldedResponse.data.message.message_template : '';
              partial = _objectSpread(_objectSpread({}, partial), {}, {
                type: 'markdown',
                content: partial.content,
                meta: {
                  inputOutputDiffRatio: '',
                  loadingStatus: loadingStatus
                }
              });
            }
            if (yieldedResponse.data.type === 'ANSWER_PART') {
              partial = _objectSpread(_objectSpread({}, partial), {}, {
                type: 'markdown',
                content: partial.content + yieldedResponse.data.message.content,
                meta: {
                  inputOutputDiffRatio: '',
                  loadingStatus: ''
                }
              });
            }
            if (!(yieldedResponse.data.type === 'FINAL_RESPONSE')) {
              _context.next = 34;
              break;
            }
            _ref2 = yieldedResponse.data, message = _ref2.message;
            if (!(parsedHasExpectedKey('message_metadata', message.message) && parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar)) {
              _context.next = 32;
              break;
            }
            _context.next = 31;
            return {
              state: 'failed',
              statusCode: message.status_code,
              reason: 'response-too-similar',
              data: {
                meta: {
                  inputOutputDiffRatio: ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message_metadata) === null || _message$message === void 0 ? void 0 : _message$message.diff_ratio) || ''
                }
              }
            };
          case 31:
            return _context.abrupt("return", _context.sent);
          case 32:
            rovoActions = message.message.actions || [];
            partial = _objectSpread(_objectSpread({}, partial), {}, {
              type: 'markdown',
              content: message.message.content,
              meta: {
                inputOutputDiffRatio: ((_message$message2 = message.message) === null || _message$message2 === void 0 || (_message$message2 = _message$message2.message_metadata) === null || _message$message2 === void 0 ? void 0 : _message$message2.diff_ratio) || '',
                loadingStatus: ''
              },
              rovoActions: rovoActions
            });
          case 34:
            if (!(yieldedResponse.data.type === 'ERROR')) {
              _context.next = 51;
              break;
            }
            statusCode = void 0;
            guard = void 0;
            error = void 0;
            retryAfter = void 0;
            if (parsedHasExpectedKey('message', yieldedResponse.data)) {
              // Get status code
              if (parsedHasExpectedKey('status_code', yieldedResponse.data.message) && typeof yieldedResponse.data.message.status_code === 'number') {
                statusCode = yieldedResponse.data.message.status_code;
              }

              // Get reason
              if (parsedHasExpectedKey('message_template', yieldedResponse.data.message)) {
                guard = yieldedResponse.data.message.message_template;
              }

              // Get error
              if (parsedHasExpectedKey('content', yieldedResponse.data.message)) {
                error = yieldedResponse.data.message.content;
              }

              // Get retryAfter
              if (parsedHasExpectedKey('headers', yieldedResponse.data) && parsedHasExpectedKey('Retry-After', yieldedResponse.data.headers)) {
                retryAfter = Number(yieldedResponse.data.headers['Retry-After']);
              }
            }
            if (!guard) {
              _context.next = 48;
              break;
            }
            if (!(statusCode === 429)) {
              _context.next = 45;
              break;
            }
            _context.next = 44;
            return {
              state: 'failed',
              apiName: 'assistance-service',
              statusCode: statusCode,
              guard: guard,
              error: error,
              retryAfter: retryAfter
            };
          case 44:
            return _context.abrupt("return", _context.sent);
          case 45:
            _context.next = 47;
            return {
              state: 'failed',
              apiName: 'assistance-service',
              statusCode: statusCode,
              guard: guard,
              error: error
            };
          case 47:
            return _context.abrupt("return", _context.sent);
          case 48:
            _context.next = 50;
            return {
              state: 'failed',
              apiName: 'assistance-service',
              statusCode: statusCode,
              guard: 'UNHANDLED_ERROR',
              error: error
            };
          case 50:
            return _context.abrupt("return", _context.sent);
          case 51:
            _context.next = 53;
            return {
              state: yieldedResponse.state,
              data: partial
            };
          case 53:
            _context.next = 57;
            break;
          case 55:
            _context.next = 57;
            return {
              state: yieldedResponse.state,
              data: partial
            };
          case 57:
            _context.next = 62;
            break;
          case 59:
            _context.next = 61;
            return {
              state: 'failed',
              reason: 'parsing'
            };
          case 61:
            return _context.abrupt("return", _context.sent);
          case 62:
            _context.next = 74;
            break;
          case 64:
            if (!(yieldedResponse.state === 'failed' && yieldedResponse.reason !== 'response-too-similar' || yieldedResponse.state === 'aup-violation')) {
              _context.next = 70;
              break;
            }
            _context.next = 67;
            return yieldedResponse;
          case 67:
            return _context.abrupt("return", _context.sent);
          case 70:
            responseTooSimilarData = {
              meta: parsedHasExpectedKey('meta', yieldedResponse.data) && parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio']
              } : partialMeta
            };
            _context.next = 73;
            return {
              state: 'failed',
              statusCode: 208,
              reason: 'response-too-similar',
              data: responseTooSimilarData
            };
          case 73:
            return _context.abrupt("return", _context.sent);
          case 74:
            _iteratorAbruptCompletion = false;
            _context.next = 6;
            break;
          case 77:
            _context.next = 83;
            break;
          case 79:
            _context.prev = 79;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;
          case 83:
            _context.prev = 83;
            _context.prev = 84;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 88;
              break;
            }
            _context.next = 88;
            return _awaitAsyncGenerator(_iterator.return());
          case 88:
            _context.prev = 88;
            if (!_didIteratorError) {
              _context.next = 91;
              break;
            }
            throw _iteratorError;
          case 91:
            return _context.finish(88);
          case 92:
            return _context.finish(83);
          case 93:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 79, 83, 93], [84,, 88, 92]]);
    })();
  });
  return _streamResponseParser.apply(this, arguments);
}